import * as _ from 'lodash';
import { HTTP } from '@/common/utils/http';
import { QueryParams } from '@/common/utils/query-params';
import { mapBodyParams } from '@/common/utils/mapBodyParams';
import { PaginationParams } from '@/common/utils/pagination-params';

export const SchoolAftercareService = {
    createAftercareSession(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare`, form);
    },

    saveDraftAftercareSession(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare-draft`, form);
    },

    getAftercareList(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`no-auth/schools/${schoolId}/aftercare`);
        return HTTP.get(url);
    },

    getAftercareListByInstructor(schoolId, instructorId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare/instructor/${instructorId}`);
        return HTTP.get(url);
    },

    getAftercareGeneralInfo(schoolId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/statistics`);
    },

    getAftercareDetailsGeneralInfo(schoolId, aftercareDayId) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/statistics`);
    },

    getAftercareSession(schoolId, aftercareId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}`);
    },

    editAftercareSession(schoolId, aftercareId, form) {
        return HTTP.put(`/schools/${schoolId}/aftercare/${aftercareId}`, form);
    },

    editDraftArtercareSession(schoolId, aftercareId, form) {
        return HTTP.put(`/schools/${schoolId}/aftercare/${aftercareId}/draft`, form);
    },

    activateDraftArtercareSession(schoolId, aftercareId, form) {
        return HTTP.put(`/schools/${schoolId}/aftercare/${aftercareId}/draft-activate`, form);
    },

    bulkUpdateAftercareSessions(schoolId, aftercareIds, form) {
        const body = {
            ids: aftercareIds,
            ...form
        };

        return HTTP.patch(`/schools/${schoolId}/aftercare`, mapBodyParams(body));
    },

    deleteAftercare(schoolId, aftercareId) {
        return HTTP.delete(`/schools/${schoolId}/aftercare/${aftercareId}`);
    },

    deleteMultipleAftercare(schoolId, aftercareIds) {
        return HTTP.delete(`/schools/${schoolId}/aftercare?ids=${aftercareIds}`);
    },

    sendBulkEmail(schoolId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/aftercare/parent-emails`, formData, { headers });
    },

    sendBulkSMS(schoolId, body) {
        return HTTP.post(`/schools/${schoolId}/aftercare/parent-sms`, body);
    },

    getXlsFileFieldNames(schoolId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/xls-fields`);
    },

    getAftercareBySchoolXls(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare/xls`, form);
    },

    getAftercareBySchoolXlsBySchedule(schoolId, ids) {
        return HTTP.get(`/schools/${schoolId}/aftercare/schedule?ids=${ids}`);
    },

    getAftercareSettings(schoolId) {
        return HTTP.get(`/schools/${schoolId}/parent-portal-settings/aftercare`);
    },

    updateAftercareSettings(schoolId, settingsForm) {
        return HTTP.put(`/schools/${schoolId}/parent-portal-settings/aftercare`, settingsForm);
    },

    getAftercareSessionName(schoolId, aftercareDayId) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/name`);
    },

    getAftercareSessionDay(schoolId, aftercareDayId) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/session-day`);
    },

    getAftercareAddOns(schoolId, aftercareId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/addons`);
    },

    getAftercareAddOnsWhichUsesBefore(schoolId, activityId, activityType, listType, childId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${activityId}/addons/children/${childId}/${_.lowerCase(listType)}`);
    },

    getAftercareFreeDaysForRosters(schoolId, aftercareId, childId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/free-days/children/${childId}`);
    },
    getAftercareFreeDaysForRostersForSchool(schoolId, aftercareId, childId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/free-days-for-school/children/${childId}`);
    },
    getAftercareFreeDaysForWaitlist(schoolId, aftercareId, childId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/free-days-waitlist/children/${childId}`);
    },

    getAftercareIdByDayId(schoolId, aftercareDayId) {
        
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/aftercare-id`);
    },

    checkAftercareDayHasChildren(schoolId, aftercareDayId) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/has-enrolled`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/aftercare.service.js